module.exports = __webpack_public_path__ + "img/thumb_image5.b5b4ddd0.jpg";